import { render, staticRenderFns } from "./PartnerGains.vue?vue&type=template&id=b023f766&scoped=true&"
import script from "./PartnerGains.vue?vue&type=script&lang=js&"
export * from "./PartnerGains.vue?vue&type=script&lang=js&"
import style0 from "./PartnerGains.vue?vue&type=style&index=0&id=b023f766&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b023f766",
  null
  
)

export default component.exports